/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {setLogin} from "../_actions/home.actions";
import {userLogin} from "./login.thunk";

import {sessionLogin} from "../session.initialize";

export const login = (payload) => dispatch => {
    dispatch(setLogin(payload));
    sessionLogin(payload);
    dispatch(userLogin());
};


// WEBPACK FOOTER //
// ./src/_thunks/home.thunk.js